"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _enhancers = require("../enhancers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchButton = function SearchButton(_ref) {
  var qeIdTag = _ref.qeIdTag,
      genericSearchValue = _ref.genericSearchValue,
      facets = _ref.facets,
      setSearchCriteria = _ref.setSearchCriteria,
      hideDetailsMenu = _ref.hideDetailsMenu;
  var facetSelections = (0, _enhancers.useContextualFacets)(facets).reduce(function (acc, _ref2) {
    var tag = _ref2.tag,
        selected = _ref2.selected;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, tag, selected));
  }, {});
  var handleSearch = (0, _react.useCallback)(function () {
    setSearchCriteria({
      keywords: genericSearchValue && genericSearchValue !== '' ? genericSearchValue.split(' ') : [],
      criterions: facetSelections
    });
    hideDetailsMenu();
  }, [facetSelections, genericSearchValue, hideDetailsMenu, setSearchCriteria]);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "data-qe-id": "".concat(qeIdTag, "_Search"),
    "data-test": "search-button",
    onClick: handleSearch,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "search.title"
  }));
};

exports.SearchButton = SearchButton;
SearchButton.propTypes = {
  qeIdTag: _propTypes["default"].string,
  facets: _propTypes["default"].array.isRequired,
  genericSearchValue: _propTypes["default"].string,
  hideDetailsMenu: _propTypes["default"].func,
  setSearchCriteria: _propTypes["default"].func.isRequired
};
var _default = SearchButton;
exports["default"] = _default;